import React from 'react';

const WrapperField = props => {
  const { children, ...rest } = props;
  return (
    <React.Fragment>
      {React.Children.map(children, child =>
        React.cloneElement(React.Children.only(child), { ...rest })
      )}
    </React.Fragment>
  );
};

export default WrapperField;
